import { render, staticRenderFns } from "./MonitoringMailQueueDetails.vue?vue&type=template&id=ca16fd60&"
import script from "./MonitoringMailQueueDetails.vue?vue&type=script&lang=js&"
export * from "./MonitoringMailQueueDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
